import {
    createTheme,
    PaletteColor,
    SimplePaletteColorOptions
} from "@mui/material/styles";

declare module "@mui/material/styles" {
    interface Palette {
        shBlack: PaletteColor;
    }

    interface PaletteOptions {
        shBlack: SimplePaletteColorOptions;
    }
}

declare module "@mui/material/IconButton" {
    interface IconButtonPropsColorOverrides {
        shBlack: true;
    }
}
declare module "@mui/material/Button" {
    interface ButtonPropsColorOverrides {
        shBlack: true;
    }
}
declare module "@mui/material/Chip" {
    interface ChipPropsColorOverrides {
        shBlack: true;
    }
}

declare module "@mui/material/styles" {
    interface BreakpointOverrides {
        is: true;
    }
}

export const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            is: 360,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1360
        }
    },
    palette: {
        shBlack: {
            main: "#27272A"
        },
        common: {
            black: "#27272A"
        },
        primary: {
            main: "#e84749"
        },
        secondary: {
            main: "#e84749"
        },
        info: {
            main: "#5d87cd"
        }
    },
    typography: {
        fontFamily: "Inter, sans-serif"
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    color: "#27272A"
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                root: {
                    zIndex: 10000000
                }
            }
        },
    }
});
